// react, react-redux, axios
import React, { Component } from "react";
import axios from 'axios';
import { connect } from "react-redux";

// Redux actions
import { checkViewPort, loadFormState, faildAppLoad, formStateLoaded } from "../actions/appActions";
import { loadServiceState } from "../actions/formActions";

// Action helpers
import * as helpers from "../helpers/actionsHelpers";

// render components
import ExemptionForm from "./exemption/ExemptionForm";
import PermitForm from "./permit/PermitForm";


import './App.scss';

class App extends Component {

  constructor(props) {
    super(props);

    // prompt before leaving 
    if (window.location.hostname !== 'localhost') {
      window.onbeforeunload = () => true
    }

    // add page to url
    if (!helpers.getUrlParameterByKey("page")) {
      window.history.pushState(
        null,
        `Page 1`,
        (window.location.search === '') ? `?page=1` : window.location.search + `&page=1`
      );
    } else {
      window.history.pushState(
        null,
        `Page 1`,
        helpers.setUrlParameter("page", "1", helpers.removeUrlParameters(["page"]))
      );      
    }    
  }

  async componentDidMount() {

    const {loadFormState, checkViewPort, loadServiceState, faildAppLoad, formStateLoaded} = this.props;

    // Retrieving a DRAFT from API
    if (helpers.getUrlParameterByKey("email") && helpers.getUrlParameterByKey("secret") && helpers.getUrlParameterByKey("formTemplateId")) {
      
      const formData = new FormData();
      formData.append("email", helpers.getUrlParameterByKey("email"));
      formData.append("secret", helpers.getUrlParameterByKey("secret"));
      formData.append("formTemplateId", helpers.getUrlParameterByKey("formTemplateId"));

      const options = {
        method: 'POST',
        data: formData,
        url: ((process.env.NODE_ENV === "development") ? process.env.REACT_APP_HOST_URL : window.location.origin) + 
        `/_webservices/heritage/draft/retrieve`
      }

      const instance = axios.create();
      const element = this;

      instance(options)
        .then(function (response) {  
          if (response.data.code) {
            throw new Error(JSON.stringify(response.data));
          }
          const payload = response.data.jsonPayload;
          loadFormState(Object.assign({}, element.props.values, payload.form))
          loadServiceState(Object.assign({}, element.props.service, {...payload.service, 
                                                                    id: response.data.id,
                                                                    secret: response.data.secret }))         
        })
        .catch(function (error) {

          faildAppLoad(`No application found for provided information<br>
            <a href="${window.location.origin + `/continue-application?email=${helpers.getUrlParameterByKey("email")}&formTemplateId=${helpers.getUrlParameterByKey("formTemplateId")}&formTemplateName=${element.props.form}`}">Try again</a>`);
        });
    } else {
      formStateLoaded()
    }

    const desktopBreakPoint = window.matchMedia("(min-width: 64rem)");
    // Checking view port and set to store if mobile or not
    checkViewPort(desktopBreakPoint);

    // Event Listeners
    desktopBreakPoint.addListener(mq =>
      checkViewPort(mq)
    );
  }

  render() {
    const { form, values, storedForm } = this.props;

    // Add all hardcoded default values here
    const passedValues = {
      ...values,
      primaryContact: {
        address: {
          country: 'Australia'
        }
      },
      applicant: {
        address: {
          country: 'Australia'
        }
      },      
      owners: [{
        address: {
          country: 'Australia'
        }
      }],
      ownersCorpManagerDetails: {
        address: {
          country: 'Australia'
        }
      }
    }

    return (
      <div className="App">

        {form && form === "exemptionForm" &&
          (
            <ExemptionForm initialValues={passedValues} storedValues={storedForm} onSubmit={() => void(0)} />
          )
        }
        {form && form === "permitForm" &&
          (
            <PermitForm initialValues={passedValues} storedValues={storedForm} onSubmit={() => void(0)} />
          )
        }
      </div>
    )
  }
}

const mapDispatchToProps = {
  checkViewPort,
  loadFormState,
  loadServiceState,
  faildAppLoad,
  formStateLoaded
};

const mapStateToProps = state => ({
  isMobile: state.app.mobile,
  storedForm: state.app.storedForm,
  service: state.service
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);


